export interface GymMeta {
  portId: string;
  dots: number;
  cost: number;
  name: string;
}

export const GYM_DATA: Record<string, GymMeta> = {
  cutlass_cove: { portId: 'cutlass_cove', dots: 2.0, cost: 0, name: 'Cutlass Cove Drill Yard' },
  port_royale: { portId: 'port_royale', dots: 4.0, cost: 0, name: 'Port Royale Drill Hall' },
  tortuga: { portId: 'tortuga', dots: 5.0, cost: 50, name: 'Tortuga Fight Pit' },
  charleston: { portId: 'charleston', dots: 6.5, cost: 200, name: 'Charleston Naval Yard' },
  nassau: { portId: 'nassau', dots: 7.0, cost: 200, name: 'Nassau Royal Academy' },
  saint_domingue: {
    portId: 'saint_domingue',
    dots: 7.5,
    cost: 200,
    name: "Madame Babineaux's Establishment",
  },
  havana: { portId: 'havana', dots: 7.0, cost: 200, name: 'Havana Maritime School' },
  maracaibo: { portId: 'maracaibo', dots: 8.0, cost: 500, name: "The Master's Forge" },
};

export function getGymForPort(portId: string): GymMeta | undefined {
  const normalised = portId.replace(/-/g, '_');
  return GYM_DATA[normalised];
}

export function estimateStatGain(
  gymDots: number,
  energyUsed: number,
  statTotal: number,
  happy: number,
): number {
  const perkModifier = 1.0;
  return (
    (perkModifier * (gymDots * 4) * energyUsed * (0.00019 * statTotal + 0.00226 * happy + 0.55)) /
    150
  );
}
